import React from "react";
import Navigation from "../components/Navigation";
import LuxuryAnimatedHero from "../components/LuxuryAnimatedHero";
import CTASections from "../components/CTASections";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <LuxuryAnimatedHero />
        <CTASections />
        <Testimonials />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
